import React from "react";
import {Link} from 'react-router-dom';
import cx from "classnames";

import {formatDate, formatNumber, trans} from "../../../common/utils";
import BetListMatch from "./bet-list-match";


const BetDetails = (
    {
        bet,
        language,
        currency,
    }
) => {

    const BetBuilderDetails = ({matches}) => {
        const listParts = {};
        matches.forEach((item) => {
            const clearId = item.id.split('_')[0];
            if (!listParts[clearId]) {
                listParts[clearId] = [];
            }
            listParts[clearId].push(item);
        });
        return <>{Object.keys(listParts).map(key => (
            <div className={cx("bets-list__match", listParts[key][0].status)} key={key}>
                <p className="bets-list__match-row">
                <span className="bets-list__match-time">
                    <span>
                        {formatDate(listParts[key][0].date, "DD.MM.YYYY, HH:mm", language)}
                    </span>
                    {listParts[key][0].isLive &&
                        <i title="Live Match"
                           className="doruk-live-match-01 coupons__live-indicator"
                        />
                    }
                </span>
                    {listParts[key][0].status &&
                        <span className="bets-list__status">
                        {trans(listParts[key][0].status[0].toUpperCase() + listParts[key][0].status.slice(1))}
                    </span>
                    }
                </p>
                {listParts[key][0].url ?
                    <Link
                        className="bets-list__match-name"
                        to={listParts[key][0].url}
                    >
                        {listParts[key][0].name}
                    </Link>
                    : <p className="bets-list__match-name">{listParts[key][0].name}</p>
                }
                {listParts[key][0].currentScore || listParts[key][0].currentStatus ?
                    <p className="bets-list__match-score">
                        <span>{listParts[key][0].currentScore || null}</span>
                        <span> {listParts[key][0].currentStatus || null}</span>
                    </p>
                    : null
                }
                <div className="bets-list__match-row--bet-builder">
                    {listParts[key].map((match) => (
                        <p className={`bets-list__match-type--bet-builder${listParts[key].length < 2 ?
                            ' bets-list__match-type--bet-builder-single'
                            : ''
                        }`}
                           key={match.id}
                        >
                            {`${match.oddsType} - ${match.oddsTypeSelection}`}
                        </p>
                    ))}
                </div>
            </div>
        ))}</>
    }

    const groups = bet?.betDetailsGroups;
    const isSystemCoupon = groups.length > 1;
    return <>
        {!groups.length ?
            <div className="bets-list__match bets-list__match--no-data">
                {trans("BET_DETAILS_NO_DATA")}
            </div>
            :
            <>
                {(isSystemCoupon && bet?.betDetailsUniqueMatches.length) && (
                    bet?.betDetailsUniqueMatches.map((match) => <BetListMatch match={match} key={match.id}/>)
                )}
                {groups.map((group) => (
                    <div className="bets-list__group" key={group.key}>
                        {!group.sortedMatches.length ?
                            <div className="bets-list__group-item">
                                {trans("BET_DETAILS_NO_DATA")}
                            </div>
                            :
                            !isSystemCoupon ?
                                <div>
                                    {
                                        group.sortedMatches[0].customOdds > 0 ?
                                            <BetBuilderDetails matches={group.sortedMatches}/>
                                            :
                                            group.sortedMatches.map((match) =>
                                                <BetListMatch match={match} key={match.id}/>
                                            )
                                    }
                                </div>
                                :
                                <div className="bets-list__group-title">
                                    <p className="bets-list__group-info">
                                        <span className="bets-list__group-info-item">
                                            <span>{trans("Stake")}</span>: {
                                            formatNumber(group.sortedMatches[0].stake, 2, language, currency)
                                        }</span>
                                        <span className="bets-list__group-info-item">
                                            <span>{trans("Payout")}</span>: {
                                            formatNumber(group.sortedMatches[0].payout, 2, language, currency)
                                        }</span>
                                    </p>
                                    <p className={cx(
                                        'bets-list__group-combination',
                                        group.status
                                    )}
                                    >{group.key}</p>
                                </div>
                        }
                    </div>)
                )}</>
        }
    </>;
};

export default BetDetails;